import React, { useState, useContext, useRef } from "react";
import DataTable from "react-data-table-component";
import { Modal } from "react-bootstrap";
import { IoCloudDownloadOutline } from "react-icons/io5";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import exportFromJSON from "export-from-json";
import dayjs from "dayjs";
// import { FiPrinter } from "react-icons/fi";
// import ReactToPrint from "react-to-print";

//internal import
import PageHeader from "../../components/common/PageHeader";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync";
import DropDownService from "../../services/DropDownService";
import ReportService from "../../services/ReportService";
import { allContext } from "../../context/AllContext";
import TableLoading from "../../components/Loading/TableLoading";

function EmployeeLeaveReport() {

    const printRef = useRef();
    const [employeeId, setEmployeeId] = useState("");
    const [employeeLeaveModalData, setEmployeeLeaveModalData] = useState([]);
    const [isViewModal, setIsViewModal] = useState(false);
    const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD"));
    const { reportSearch, setReportSearch } = useContext(allContext);

    const { data, loading, tableLoading } = useAsync(() => ReportService.getAllEmployeeLeaveReportData({ employeeId: employeeId, fromDate: startDate, toDate: endDate, page: "", limit: "" }));
    const { data: employeeDropDown } = useAsync(() => DropDownService.employeeDropDown());

    let columnT = ""

    columnT = [
        {
            name: "EMPLOYEE ID",
            selector: (row) => row.employeeCode,
            sortable: true,
            cell: (row) => <b>{row.employeeCode}</b>
        },
        {
            name: "NAME",
            selector: (row) => row.name,
            sortable: true
        },
        {
            name: "USER NAME",
            selector: (row) => row.employeeUsername,
            sortable: true,
            cell: row => <div><span className="fw-bold ms-1">{row.employeeUsername}</span></div>,
        },

        {
            name: "NO OF DAYS",
            selector: (row) => row.totalLeave,
            sortable: true
        }
    ];
    let modalColumnT = ""

    modalColumnT = [
        {
            name: "FROM",
            selector: (row) => row.leavefrom,
            sortable: true,
            cell: (row) => <div>{row.leavefrom}</div>
        },
        {
            name: "TO",
            selector: (row) => row.leaveTo,
            sortable: true
        },
        {
            name: "LEAVE STATUS",
            selector: (row) => row.leaveStatus,
            sortable: true,
            cell: row => <div className={`p-2 badge ${row.leaveStatus === "Approved" ? 'bg-success' : row.leaveStatus === "Rejected" ? "bg-danger" : "bg-warning"}`}>{row.leaveStatus}</div>,
        },
        {
            name: "REASON",
            selector: (row) => row.reason,
            sortable: true,
            cell: row => <div><span className="fw-bold ms-1">{row.reason}</span></div>,
        },
        {
            name: "NO OF DAYS",
            selector: (row) => row.noOfDays,
            sortable: true
        }
    ];

    const handleDownloadReport = async (downloadType) => {
        try {
            const res = await ReportService.getAllEmployeeLeaveReportData({ employeeId: employeeId, fromDate: startDate, toDate: endDate, page: "", limit: "" });
            if (downloadType === "pdf") {
                const exportData = res?.data?.map((val) => {
                    return [
                        val.employeeCode,
                        val.name,
                        val.employeeUsername,
                        val.totalLeave,
                    ]
                });
                const head = ["EMPLOYEE ID", "NAME", "USER NAME", "NO OF DAYS"];
                const unit = "pt";
                const size = "A4"; // Use A1, A2, A3 or A4
                const orientation = "landscape"; // portrait or landscape  
                const doc = new jsPDF(orientation, unit, size);
                doc.setFontSize(15);
                const headers = [head];
                let content = {
                    startY: 50,
                    head: headers,
                    body: exportData
                };

                const header = "Employee Leave Report";
                const footer = dayjs().format("DD-MM-YYYY hh:mm A");
                const pageSize = doc.internal.pageSize;
                const pageWidth = pageSize.width || pageSize.getWidth();
                const pageHeight = pageSize.height || pageSize.getHeight();

                doc.text(header, 40, 15);
                doc.text("CRM with Sunpro", 500, 15, { baseline: 'top' });
                doc.autoTable(content);
                doc.setFontSize(8);
                doc.text(footer, pageWidth / 1.2, pageHeight - 50, { baseline: 'bottom' });

                doc.save("employee-leave-report" + Date.now() + ".pdf");
            }
            else if (downloadType === "csv" || downloadType === "xls") {
                const exportData = res?.data?.map((val) => {
                    return {
                        "EMPLOYEE ID": val.employeeCode,
                        "NAME": val?.name,
                        "USER NAME": val.employeeUsername,
                        "NO OF DAYS": val.totalLeave
                    }
                });
                exportFromJSON({
                    data: exportData,
                    fileName: "employee-leave-report" + Date.now(),
                    exportType: downloadType,
                });
            }
        } catch (error) {
            console.error("error", error)
        }
    }

    const handleClearFilter = () => {
        setEmployeeId("");
        setReportSearch(!reportSearch);
    }
    const handleModalOpen = (row) => {
        setEmployeeLeaveModalData(row);
        setIsViewModal(true);
    }

    return (
        <div className="container-xxl">
            {loading ? <ModalLoading loading={loading} /> :
                <>
                    <PageHeader headerTitle="Employee Leave Report" renderRight={() => {
                        return <div className="col-auto d-flex w-sm-100">
                        </div>
                    }} />
                    <div className="row">
                        <div className="col-lg-12 pb-4 d-flex justify-content-between">
                            <div className=" col-lg-3">
                                <label className="form-label">Start Date</label>
                                <input
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    className="form-control"
                                    placeholder="Search Project name and category"
                                    aria-label="search"
                                    max={endDate}
                                    aria-describedby="addon-wrapping" />
                            </div>
                            <div className=" col-lg-3">
                                <label className="form-label">End Date</label>
                                <input
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    min={startDate}
                                    className="form-control"
                                    placeholder="Search Project name and category"
                                    aria-label="search"
                                    aria-describedby="addon-wrapping" />
                            </div>
                            <div className=" col-lg-3">
                                <label className="form-label">Select Employee</label>
                                <select className="form-select"
                                    value={employeeId}
                                    onChange={(e) => setEmployeeId(e.target.value)}
                                >
                                    <option value="">--- All Employee ---</option>
                                    {employeeDropDown?.data?.map((val, idx) => (
                                        <option key={idx} value={val?.value}>{val?.label}</option>
                                    ))
                                    }
                                </select>
                            </div>
                            <div className="ms-5 mt-4 p-2 me-2">
                                <button className="btn btn-dark  px-4 me-2" type="submit" onClick={() => handleClearFilter()}><span className="text-white dark:text-gray-200">Reset</span></button>
                                <button className="btn btn-dark  px-4 " type="submit" onClick={() => setReportSearch(!reportSearch)}><span className="text-white dark:text-gray-200">Search</span></button>
                            </div>
                        </div>
                        <div className="col-lg-12 p-4 pt-6 mt-1 d-flex justify-content-end ">
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("csv")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span> CSV </button>
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("xls")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span>EXCEL</button>
                            <button className={`btn btn-dark btn-set-task w-sm-100 m-2 ${data?.data.length === 0 && "opacity-50"}`} onClick={() => data?.data.length !== 0 && handleDownloadReport("pdf")}><span className=" me-2 fs-6"><IoCloudDownloadOutline /></span>PDF</button>
                            {/* <ReactToPrint
                                trigger={() => (
                                    <button className="btn btn-dark btn-set-task w-sm-100 m-2">
                                        <span className=" me-2 fs-6"><FiPrinter /></span>
                                        Print
                                    </button>
                                )}

                                content={() => printRef.current}
                                documentTitle="Invoice"
                            /> */}
                        </div>
                    </div>
                    <div className="row clearfix g-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body" ref={printRef}>
                                    <DataTable
                                        title="Employee Leave Report"
                                        columns={columnT}
                                        data={data?.data}
                                        defaultSortField="title"
                                        pagination
                                        selectableRows={false}
                                        className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                        highlightOnHover={true}
                                        progressPending={tableLoading}
                                        progressComponent={<TableLoading row={10} col={7} width={160} height={20} />}
                                        onRowClicked={(row) => handleModalOpen(row)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <Modal show={isViewModal} size="lg" centered onHide={() => { setIsViewModal(false) }}>
                        <Modal.Header closeButton>
                            <Modal.Title className="fw-bold w-100 text-center">{employeeLeaveModalData?.name} Leave Detail</Modal.Title>
                        </Modal.Header>
                        <Modal.Body >
                            <div className="row clearfix g-3">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-body" ref={printRef}>
                                            <DataTable
                                                title="Employee Leave Report Modal"
                                                columns={modalColumnT}
                                                data={employeeLeaveModalData.leaveData || []}
                                                defaultSortField="title"
                                                selectableRows={false}
                                                className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                                highlightOnHover={true}
                                                progressPending={loading}
                                                progressComponent={<ModalLoading loading={loading} />}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                </>
            }
        </div>
    )
}

export default EmployeeLeaveReport;